import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface MaintenanceConfig {
  enabled: boolean;
  message?: string;
  enabledAt?: string;
  pausedCount?: number;
  scheduledAt?: string;
  scheduledMessage?: string;
}

export const maintenanceApi = {
  async getMaintenanceConfig(): Promise<MaintenanceConfig> {
    const response = await axios.get(`${API_URL}/api/public/maintenance`);
    return response.data;
  },
};
